// source: pbtypes/gen/flir_boson_driver/isotherm_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flir_boson_driver_colorlut_pb = require('../../../pbtypes/gen/flir_boson_driver/colorlut_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_colorlut_pb);
var pbtypes_gen_flir_boson_driver_isotherm_blending_mode_pb = require('../../../pbtypes/gen/flir_boson_driver/isotherm_blending_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_isotherm_blending_mode_pb);
var pbtypes_gen_flir_boson_driver_isotherm_color_pb = require('../../../pbtypes/gen/flir_boson_driver/isotherm_color_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_isotherm_color_pb);
var pbtypes_gen_flir_boson_driver_isotherm_fill_mode_pb = require('../../../pbtypes/gen/flir_boson_driver/isotherm_fill_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_isotherm_fill_mode_pb);
var pbtypes_gen_flir_boson_driver_isotherm_type_pb = require('../../../pbtypes/gen/flir_boson_driver/isotherm_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_isotherm_type_pb);
var pbtypes_gen_flir_boson_driver_range_pb = require('../../../pbtypes/gen/flir_boson_driver/range_pb.js');
goog.object.extend(proto, pbtypes_gen_flir_boson_driver_range_pb);
goog.exportSymbol('proto.flir_boson_driver.IsothermSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flir_boson_driver.IsothermSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flir_boson_driver.IsothermSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flir_boson_driver.IsothermSettings.displayName = 'proto.flir_boson_driver.IsothermSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flir_boson_driver.IsothermSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.flir_boson_driver.IsothermSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flir_boson_driver.IsothermSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.IsothermSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
rangeC: (f = msg.getRangeC()) && pbtypes_gen_flir_boson_driver_range_pb.Range.toObject(includeInstance, f),
cutoffC: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
fillMode: jspb.Message.getFieldWithDefault(msg, 8, 0),
blendMode: jspb.Message.getFieldWithDefault(msg, 4, 0),
color: jspb.Message.getFieldWithDefault(msg, 5, 0),
palette: jspb.Message.getFieldWithDefault(msg, 7, 0),
enable: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flir_boson_driver.IsothermSettings}
 */
proto.flir_boson_driver.IsothermSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flir_boson_driver.IsothermSettings;
  return proto.flir_boson_driver.IsothermSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flir_boson_driver.IsothermSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flir_boson_driver.IsothermSettings}
 */
proto.flir_boson_driver.IsothermSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flir_boson_driver.IsothermType.Enum} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new pbtypes_gen_flir_boson_driver_range_pb.Range;
      reader.readMessage(value,pbtypes_gen_flir_boson_driver_range_pb.Range.deserializeBinaryFromReader);
      msg.setRangeC(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCutoffC(value);
      break;
    case 8:
      var value = /** @type {!proto.flir_boson_driver.IsothermFillMode.Enum} */ (reader.readEnum());
      msg.setFillMode(value);
      break;
    case 4:
      var value = /** @type {!proto.flir_boson_driver.IsothermBlendingMode.Enum} */ (reader.readEnum());
      msg.setBlendMode(value);
      break;
    case 5:
      var value = /** @type {!proto.flir_boson_driver.IsothermColor.Enum} */ (reader.readEnum());
      msg.setColor(value);
      break;
    case 7:
      var value = /** @type {!proto.flir_boson_driver.Colorlut.Enum} */ (reader.readEnum());
      msg.setPalette(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flir_boson_driver.IsothermSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flir_boson_driver.IsothermSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flir_boson_driver.IsothermSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.IsothermSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRangeC();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_flir_boson_driver_range_pb.Range.serializeBinaryToWriter
    );
  }
  f = message.getCutoffC();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getFillMode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getBlendMode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getColor();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getPalette();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional IsothermType.Enum type = 1;
 * @return {!proto.flir_boson_driver.IsothermType.Enum}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getType = function() {
  return /** @type {!proto.flir_boson_driver.IsothermType.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flir_boson_driver.IsothermType.Enum} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Range range_c = 2;
 * @return {?proto.flir_boson_driver.Range}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getRangeC = function() {
  return /** @type{?proto.flir_boson_driver.Range} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flir_boson_driver_range_pb.Range, 2));
};


/**
 * @param {?proto.flir_boson_driver.Range|undefined} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
*/
proto.flir_boson_driver.IsothermSettings.prototype.setRangeC = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.clearRangeC = function() {
  return this.setRangeC(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flir_boson_driver.IsothermSettings.prototype.hasRangeC = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float cutoff_c = 3;
 * @return {number}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getCutoffC = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.setCutoffC = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional IsothermFillMode.Enum fill_mode = 8;
 * @return {!proto.flir_boson_driver.IsothermFillMode.Enum}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getFillMode = function() {
  return /** @type {!proto.flir_boson_driver.IsothermFillMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.flir_boson_driver.IsothermFillMode.Enum} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.setFillMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional IsothermBlendingMode.Enum blend_mode = 4;
 * @return {!proto.flir_boson_driver.IsothermBlendingMode.Enum}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getBlendMode = function() {
  return /** @type {!proto.flir_boson_driver.IsothermBlendingMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.flir_boson_driver.IsothermBlendingMode.Enum} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.setBlendMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional IsothermColor.Enum color = 5;
 * @return {!proto.flir_boson_driver.IsothermColor.Enum}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getColor = function() {
  return /** @type {!proto.flir_boson_driver.IsothermColor.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.flir_boson_driver.IsothermColor.Enum} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.setColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Colorlut.Enum palette = 7;
 * @return {!proto.flir_boson_driver.Colorlut.Enum}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getPalette = function() {
  return /** @type {!proto.flir_boson_driver.Colorlut.Enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.flir_boson_driver.Colorlut.Enum} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.setPalette = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional bool enable = 6;
 * @return {boolean}
 */
proto.flir_boson_driver.IsothermSettings.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flir_boson_driver.IsothermSettings} returns this
 */
proto.flir_boson_driver.IsothermSettings.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


goog.object.extend(exports, proto.flir_boson_driver);
